import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';

export default class TooltipLine {
  constructor() {
    this.lineLabel;
    this.lineLabelTag;
    this.createlineLabel();
  }
createlineLabel(){
    this.lineLabelTag = document.createElement('div');
    this.lineLabelTag.className = 'label';
    this.lineLabelTag.textContent = ``;
    this.lineLabel = new CSS2DObject(this.lineLabelTag);
    this.lineLabel.name = 'tooltipLine'
    return this.lineLabel
  }

  setNewlineLabelPosition(position, text){
    this.lineLabel.position.set(position.x, position.y, position.z)
    this.lineLabelTag.textContent = `${Math.round(text)}  mm`;
  }

}